import apiFF from "../apiFF";
import { Constants } from "../../../utils/Constants";

function base(contexto) {
	return `${Constants.baseUrlV2}/${contexto}`;
}

export function atualizarDados(contexto, payload) {
	return apiFF.put(`${base(contexto)}/perfil`, payload);
}

export function atualizarEndereco(contexto, payload) {
	return apiFF.put(`${base(contexto)}/perfil/endereco`, payload);
}

export function reenviarEmailVerificacao(contexto) {
	return apiFF.post(`${base(contexto)}/email/verify/resend`);
}

export function verificarStatusEmail(contexto) {
	return apiFF.get(`${base(contexto)}/email/verify/status`);
}
